import type { IconSvgObject } from './types';

const TrampolineIcon: IconSvgObject = [
  ["path", { d: "M2 10V18M12 16V20M22 10V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["ellipse", { cx: "12", cy: "10", rx: "10", ry: "6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TrampolineIcon;
